module.exports = __webpack_public_path__ + "static/media/linkedin-icon.c299087c.svg";